import { Open_Sans } from 'next/font/google';
import localFont from 'next/font/local';

const OpenSansFont = Open_Sans({
  weight: ['400', '600', '700'],
  subsets: ['latin'],
  style: ['normal'],
  fallback: ['sans-serif']
});

const HomemadeApple = localFont({
  src: [
    {
      path: '../../../public/assets/fonts/HomemadeApple/HomemadeApple-Regular.ttf',
      weight: '400',
      style: 'normal'
    }
  ]
});

const fonts = {
  main: OpenSansFont.style.fontFamily,

  homeMade: HomemadeApple.style.fontFamily,
  heading: OpenSansFont.style.fontFamily
};

export default fonts;
